import React from "react";
import Table from "../../../components/table/table";
import Icon from "../../../components/icon/icon";
import { Review } from "../../../types";
import { ReviewTableProps } from "../types/reviews-types";
import { ITEMS_PER_PAGE_OPTIONS } from "../../../constants/pagination";

export const ReviewTable: React.FC<ReviewTableProps> = ({
  reviews,
  isLoading,
  currentPage,
  itemsPerPage,
  totalPages,
  onEdit,
  onDelete,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const columns = [
    {
      title: "Имя",
      dataIndex: "customerName" as keyof Review,
      key: "customerName",
    },
    {
      title: "Рейтинг",
      dataIndex: "rating" as keyof Review,
      key: "rating",
      render: (rating: number) => `${rating}/5`,
    },
    {
      title: "Дата",
      dataIndex: "reviewDate" as keyof Review,
      key: "reviewDate",
      render: (date: string) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString("ru-RU");
      },
    },
    {
      title: "Содержание",
      dataIndex: "content" as keyof Review,
      key: "content",
      render: (text: string) => {
        if (!text) return "";
        const maxLength = 60;
        return text.length > maxLength
          ? `${text.substring(0, maxLength)}...`
          : text;
      },
    },
    {
      title: "Источник",
      dataIndex: "source" as keyof Review,
      key: "source",
      render: (source: string, record: Review) => (
        <a
          href={record.sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="review__link"
        >
          {source}
        </a>
      ),
    },
    {
      title: "Действия",
      key: "action",
      dataIndex: "id" as keyof Review,
      render: (_: any, record: Review) => (
        <div className="review__actions">
          <button
            onClick={() => onEdit(record)}
            className="review__action-btn"
            title="Редактировать"
          >
            <Icon name="pencil" size="small" />
          </button>
          <button
            onClick={() => onDelete(record)}
            className="review__action-btn"
            title="Удалить"
          >
            <Icon name="delete" size="small" />
          </button>
        </div>
      ),
    },
  ];

  const handleItemsPerPageChange = (value: string): void => {
    onItemsPerPageChange(parseInt(value));
  };

  return (
    <div className="review__table-container">
      <Table
        columns={columns}
        dataSource={reviews}
        rowKey="id"
        loading={isLoading}
        emptyMessage="Отзывы не найдены"
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />

      <div className="review__pagination">
        <div className="review__pagination-info">
          Показано{" "}
          {Math.min((currentPage - 1) * itemsPerPage + 1, reviews.length)} -{" "}
          {Math.min(currentPage * itemsPerPage, reviews.length)} из{" "}
          {reviews.length}
        </div>

        <div className="review__pagination-controls">
          <select
            value={itemsPerPage}
            onChange={(e) => handleItemsPerPageChange(e.target.value)}
            className="review__page-size-select"
          >
            {ITEMS_PER_PAGE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option} на странице
              </option>
            ))}
          </select>

          <div className="review__page-buttons">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="review__page-btn"
            >
              <Icon name="left" size="small" />
            </button>

            <span className="review__page-info">
              {currentPage} из {totalPages}
            </span>

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="review__page-btn"
            >
              <Icon name="right" size="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
